let statoIniziale = []

export const storico = (state = statoIniziale, action)=>{
    let newState = state.slice(0,5)
    newState.unshift(action.type)
    return newState
}